<div class="container-fluid col-10">
  <div>
    <h2>Messages</h2>
  </div>
  <hr>

  <div class="card">
    <div class="card-body">
      <div>
        No messages yet... say hi by using the message box below
      </div>

      <ul class="chat">
        <li>
          <!-- to them -->
          <div>
            <span class="chat-img float-left">
              <img src="{{'./assets/img/lachmann/template/user.png'}}" alt="dfsgdsfg" class="rounded-circle">
            </span>
            <div class="chat-body">
              <div class="header">
                <strong class="primary-font"> Carrier</strong>
                <small class="text-muted float-right">
                  <span class="fa fa-clock-o"> 08:00</span>
                </small>
              </div>
              <p>Can you plase inform current status?</p>
            </div>
          </div>

          <!-- to me -->
          <div>
            <span class="chat-img float-right">
              <img src="{{'./assets/img/lachmann/template/user.png'}}" alt="sgdfsgdfs" class="rounded-circle">
            </span>
            <div class="chat-body">
              <div class="header">
                <small class="text-muted">
                  <span class="fa fa-clock-o">09:05</span>
                  <span *ngIf="1==1" class="text-danger">(unread)</span>
                  <span *ngIf="1!=1" class="text-success">(Read 11:00)</span>
                </small>
                <strong class="primary-font float-right">Agent</strong>

              </div>
              <p>Departure time estimation is 07:00PM</p>
            </div>
          </div>
        </li>
      </ul>

    </div>

    <div class="card-footer">

      <form #messageForm="ngForm" (ngSubmit)="messageForm.valid  ">
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="Send a private message" aria-label="Recipient's username"
            aria-describedby="basic-addon2">
          <div class="input-group-append">
            <button type="submit" class="btn btn-success my-2 my-sm-0 btn-round">Send</button>
          </div>
        </div>
      </form>

    </div>


  </div>

</div>
